import * as table from './TableData'
import {
    CurrentTime,
    GET_COMPANY_FROM_URL,
    currentDate_dmy,
    date_dmy_func,
} from "../../components/Common/CommonFunction";

export const pageBorder = (doc) => {
    doc.setDrawColor(0, 0, 0);
    doc.line(570, 16, 30, 16);
    doc.line(30, 815, 30, 16);
    doc.line(570, 815, 570, 16);
    doc.line(570, 815, 30, 815);
};

export const pageHeder = (doc) => {
    const companyCode = GET_COMPANY_FROM_URL();
    let storedTheme = null;
    try {
        storedTheme = JSON.parse(localStorage.getItem(`${companyCode}_companyTheme`));
    } catch (e) { }
    const logo = localStorage.getItem(`${companyCode}_CompanyLogo`);

    let logoToUse = null;
    if (!companyCode || companyCode === "Default") {
        logoToUse = logo;
    } else if (storedTheme?.CompanyLogo) {
        logoToUse = logo;
    }
    if (logoToUse) {
        doc.addImage(logoToUse, 'PNG', 33, 17, 60, 38, null, 'FAST');
    }

    doc.addFont("Arial", 'Normal');
    doc.setFont('Arial');
    doc.setFontSize(14);
    doc.setFont(undefined, 'bold');
    doc.text('SCHEME MASTER REPORT', 250, 40, { align: 'center' });
    doc.setFont(undefined, 'normal');
};

/** ⭐ dateRange = { fromDate, toDate } computed from the schemes array */
export const reportHeder3 = (doc, dateRange = {}) => {
    doc.setFont('Tahoma');
    doc.setFontSize(9);
    doc.setDrawColor(0, 0, 0);
    doc.line(570, 38, 408, 38);
    doc.line(408, 65, 408, 16);

    doc.setFont(undefined, 'bold');
    doc.setFontSize(8);
    doc.text(`From Date: ${dateRange.fromDate ? date_dmy_func(dateRange.fromDate) : "-"}`, 415, 27);
    doc.text(`To Date: ${dateRange.toDate ? date_dmy_func(dateRange.toDate) : "-"}`, 415, 52);
    doc.setFont(undefined, 'normal');

    doc.line(570, 63, 30, 63);
};

export const tableBody = (doc, schemes, dateRange = {}) => {

    const options = {
        didParseCell: (data1) => {
            const rowType = data1.row.raw[8]; // ⭐ was [7]
            if (rowType === "subtotal") {
                data1.row.cells[0].colSpan = 4;
                data1.row.cells[0].styles.halign = "right";
                data1.row.cells[0].styles.fontStyle = "bold";
                data1.row.cells[0].styles.fillColor = [235, 235, 235];
                data1.row.cells[4].styles.fontStyle = "bold";       // ⭐ Voucher Amount
                data1.row.cells[4].styles.fillColor = [235, 235, 235];
                data1.row.cells[5].styles.fontStyle = "bold";       // Bill Amount
                data1.row.cells[5].styles.fillColor = [235, 235, 235];
                data1.row.cells[6].styles.fontStyle = "bold";       // Total Coupon
                data1.row.cells[6].styles.fillColor = [235, 235, 235];
                data1.row.cells[7].styles.fontStyle = "bold";       // Used Coupon
                data1.row.cells[7].styles.fillColor = [235, 235, 235];
            }
            if (rowType === "grandtotal") {
                data1.row.cells[0].colSpan = 4;
                data1.row.cells[0].styles.halign = "right";
                data1.row.cells[0].styles.fontStyle = "bold";
                data1.row.cells[0].styles.fontSize = 8;
                data1.row.cells[0].styles.fillColor = [211, 211, 211];
                data1.row.cells[4].styles.fontStyle = "bold";
                data1.row.cells[4].styles.fillColor = [211, 211, 211];
                data1.row.cells[5].styles.fontStyle = "bold";
                data1.row.cells[5].styles.fillColor = [211, 211, 211];
                data1.row.cells[6].styles.fontStyle = "bold";
                data1.row.cells[6].styles.fillColor = [211, 211, 211];
                data1.row.cells[7].styles.fontStyle = "bold";
                data1.row.cells[7].styles.fillColor = [211, 211, 211];
            }
        },
        pageBreak: 'auto',
        rowPageBreak: 'avoid',
        margin: { left: 30, right: 25, top: 63, bottom: 40 },
        theme: 'grid',
        headerStyles: {
            cellPadding: 3, lineWidth: 0.8, valign: 'top', fontStyle: 'bold',
            halign: 'center', fillColor: 'white', textColor: [0, 0, 0],
            fontSize: 7, lineColor: 'black',
        },
        bodyStyles: {
            columnWidth: 'wrap', textColor: [30, 30, 30], cellPadding: 4,
            fontSize: 7, lineColor: [6, 3, 1],
        },
        columnStyles: {
            0: { valign: 'top', columnWidth: 115, halign: 'left' },
            1: { columnWidth: 95, halign: 'left' },
            2: { columnWidth: 65, halign: 'center' },
            3: { columnWidth: 65, halign: 'center' },
            4: { columnWidth: 60, halign: 'right' },  // ⭐ Voucher Amount
            5: { columnWidth: 60, halign: 'right' },  // Bill Amount
            6: { columnWidth: 40, halign: 'right' },  // Total Coupon
            7: { columnWidth: 40, halign: 'right' },  // Used Coupon
        },
        tableLineColor: 'black',
        startY: 63,
        didDrawPage: () => {
            pageBorder(doc);
            pageHeder(doc);
            reportHeder3(doc, dateRange);
        },
    };

    doc.autoTable(table.columns, table.Rows(schemes), options);
};

export const pageFooter = (doc) => {
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(7);
        doc.text('Print Date :' + String(currentDate_dmy) + ' Time ' + String(CurrentTime()), 30, 828);
        doc.text('Page ' + String(i) + ' of ' + String(pageCount), 500, 828);
    }
};